module.exports = "/assets/131f9d9f0d3a69d390131d8808b0ce25.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/SC.png
// module id = 1816
// module chunks = 0